// extracted by mini-css-extract-plugin
module.exports = {"container":"UploadVideo_container__2Qlbs"};